import { useEffect } from 'react';
import { DEFAULT_AGENT_ID } from 'constants/agents.constants';
import type { UseFormReturnType } from 'hooks/use-form.hook';
import { useGetAgents } from 'stores/rq/agents';
import { isSaasDefaultAgent } from 'utils/agent.utils';

// A new self-hosted VCS connection starts on the organization default, which only works while that
// default is self-hosted - the env0 cloud agent cannot reach a self-hosted VCS. What the connection
// already stores is left alone, so editing an old one does not open on an empty field.
//
// This lives in the form owner rather than in the agent picker: react-hook-form registers a controlled
// field from a child effect, and a clear issued from the picker runs before that registration, so it is
// dropped whenever the agent list is already cached and there is no second render to retry on.
export const useDropSaasDefaultAgentKey = (
  form: UseFormReturnType<any>,
  vcsConnection?: { id?: string; vcsAgentKey?: string }
) => {
  const { data: agents } = useGetAgents(true);
  const { getValues, setValue } = form;
  // A connection that follows the organization default stores no agent key at all, so only the absence of
  // an id tells a new connection from an existing one that already reads as the default.
  const shouldDrop = !vcsConnection?.id && !vcsConnection?.vcsAgentKey && isSaasDefaultAgent(agents);

  useEffect(() => {
    if (shouldDrop && getValues('vcsAgentKey') === DEFAULT_AGENT_ID) {
      setValue('vcsAgentKey', undefined, { shouldDirty: false });
    }
  }, [shouldDrop, getValues, setValue]);
};
